export { default as FemaleIcon } from '~icons/tabler/gender-female';
